import React, {useState} from 'react';
import ReactDOMServer from "react-dom/server";
import Translator from "../helpers/Translator";
import { AppRemixIcon } from '@/layout/AppComponents';
import AppModal from "./AppModal";
import colors from '../../../constants/colors';

export default function HelpModal(props) {
    const {
    children,
    size = 'md',
    iconSize = 12,
    iconColor = colors.primary,
    iconFilled = false,
    className = '',
  } = props;
    const [show, setShow] = useState(false);

    return (
        <>
            <AppModal
                show={show}
                isConfirmBtn={true}
                isCancelBtn={false}
                title={ReactDOMServer.renderToString(<Translator file='user' name='client.help' />)}
                size={size}
                confirmBtnText={ReactDOMServer.renderToString(<Translator file='general' name='understood' />)}
                onClose={() => setShow(false)}
                onConfirm={() => setShow(false)}>
                {children}
            </AppModal>
            <span onClick={() => setShow(true)} className={`text-worldlex pointer ${className}`}>
                <AppRemixIcon icon="question" color={iconColor} size={iconSize} filled={iconFilled} />
            </span>
        </>
    );
}
